module.exports = __webpack_public_path__ + "static/media/next-arrow-black.a166c524.svg";